import { format } from '@/services/datetime'

export default (value, formatPattern) => {
  return format.toLocal(value, formatPattern)
}
